import { gsap } from "gsap";

export default () => {
	
	const faqWrapper = document.querySelector('.faq__list');

	faqWrapper?faqHandle():false;

	function faqHandle() {
		const items = faqWrapper.querySelectorAll('.faq__item');
	
		const loadMoreButton = document.querySelector('.faq__btn');

		items.forEach((el, index) =>{
			const info = el.querySelector('.faq__item-info');
			const button = el.querySelector('.faq__item-btn');
			info.setAttribute('data-height', info.scrollHeight);

			button.addEventListener('click', ()=>{
				if (el.classList.contains('active')){
					gsap.to(info, {
						height: 0,
						duration: 0.7,
						onStart: () =>{
							el.classList.remove('active')
						},
					})
				} else {
					gsap.to(info, {
						height: info.scrollHeight,
						duration: 0.7,
						onStart: () =>{
							el.classList.add('active')
						},
					})
				}
				
			})
			
			loadMoreButton? loadHandle():false;

			function loadHandle(){
				const showItems = parseInt(faqWrapper.dataset.showItems);
				if(index > showItems - 1 ){
					el.style.height = 0;
					el.style.paddingBottom = 0;
				}
				loadMoreButton.addEventListener('click', () => {
					items.forEach((el) => {
						el.style.paddingBottom = '10px';
						gsap.to(el,{
							height: 'auto',
							duration: 0.5,
							onStart: () =>{
								
								loadMoreButton.style.display = 'none'
							}
						})
					})
				})
			}
		})
	}
}